<script setup lang="ts">
import { Components } from '@/api/generated/api';
import UserAccessRightList from '@/core/elements/UserAccessRightList.vue';
import { IUserWithPermissions } from '@/interfaces';
import { ref, toRefs, watch } from 'vue';

const emit = defineEmits<{
  continue: [];
  'update:users-with-access': [teamMembers: IUserWithPermissions[]];
}>();

const props = withDefaults(
  defineProps<{
    schoolClass: Components.Schemas.SchoolClassDto | null;
    usersWithAccess: IUserWithPermissions[];
    availableSchoolSubjects: Components.Schemas.SchoolSubjectDto[];
    availableSchoolSubjectGroups: Components.Schemas.SchoolSubjectGroupDto[];
    showDescription?: boolean;
  }>(),
  {
    showDescription: true,
  },
);
const { usersWithAccess } = toRefs(props);

const usersWithAccessInternal = ref<IUserWithPermissions[]>([]);

const handleUpdateUsers = (teamMembers: IUserWithPermissions[]): void => {
  emit('update:users-with-access', teamMembers);
};

const onSubmit = (): void => {
  emit('continue');
};

defineExpose({
  onSubmit,
});

watch(
  usersWithAccess,
  () => {
    usersWithAccessInternal.value = usersWithAccess.value;
  },
  { immediate: true },
);
</script>

<template>
  <form class="grid h-full min-w-0 grid-rows-[min-content_1fr] px-lg md:px-content" @submit="onSubmit">
    <p v-if="showDescription" class="text-subtitle mb-md">
      {{ $t('classes.archiveClassTeamDescription') }}
    </p>

    <UserAccessRightList
      :available-school-subject-groups="availableSchoolSubjectGroups"
      :available-school-subjects="availableSchoolSubjects"
      :label="$t('accessRights.currentStaffDescription')"
      :school-class="schoolClass"
      :users-with-access="usersWithAccessInternal"
      mode="archive"
      @update:users-with-access="handleUpdateUsers"
    />
  </form>
</template>
